export default __webpack_public_path__ + "static/media/Letter_of_Interest.cba52608.pdf";